import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  metaMaskWallet,
  rabbyWallet,
  rainbowWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { beamWallet } from './wallets/beamWallet';

type ConnectorsConfig = Parameters<typeof connectorsForWallets>[1];

export type Connectors = ReturnType<typeof connectorsForWallets>;

/**
 * Retrieves a set of (RainbowKit) connectors.
 *
 * @param {ConnectorsConfig} config - The configuration object for the connectors.
 * @returns {Connectors} The connectors.
 */
export const getConnectors = (config: ConnectorsConfig): Connectors =>
  connectorsForWallets(
    [
      {
        groupName: 'wallets',
        wallets: [
          beamWallet,
          injectedWallet,
          rainbowWallet,
          metaMaskWallet,
          walletConnectWallet,
          rabbyWallet,
        ],
      },
    ],
    config,
  );
